import styled from 'styled-components';

export const IbiboMf = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 11;
  background-color: rgb(34, 116, 224);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  padding-right: ${props => props.theme.spacing.custom(12)};

  & .searchWidget {
    position: relative;
  }
  & .searchWidget label {
    color: white;
    padding-bottom: 0.5rem;
    padding-left: 0.2rem;
    display: flex;
    opacity: 0.6;
    font-size: 12px;
  }
  & .searchWidget input {
    background-color: rgb(25, 88, 182);
    color: white;
    border: none;
    font-size: 1.4rem;
    font-family: Quicksand;
    font-weight: bold;
    display: block;
    width: 100%;
    height: 4.2rem;
    padding: 1rem 0.5rem 1.2rem 1rem;
    line-height: 1.3;
    border-radius: 0.8rem;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
  }
  & .searchWidget .travellDatedMF {
    position: absolute;
    width: 330px;
    /* height: 470px; */
    background: #ffffff;
    padding: 25px;
    & .travellDateTag {
      background: #ffffff;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      padding: 12px 0;
      width: 80px;
      text-align: center;
      color: #2276e3;
      display: inline-block;
      margin-right: 20px;
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 20px;
      cursor: pointer;
      &:hover,
      &.travelDateSelected {
        background: #2276e3;
        color: #fff;
      }
      &.fullWidth {
        width: 100%;
      }
      &.travellDateTag:nth-child(3n) {
        margin: 0px;
      }
    }
  }
`;

export const TripSlider = styled.div`
  & .durationRangeOuter {
    width: 220px;
    margin: 0 auto;
  }

  & .fltSld-target {
    width: 270px;
    height: 4px;
    border: none;
    border-radius: 6px;
    background: #eee;
    margin-top: 42px;
    margin-left: -50px;

    &:before {
      content: '';
      position: absolute;
      width: 50px;
      height: 4px;
      left: 0px;
      top: 0px;
      background: #fff;
      z-index: 11;
    }
  }
  & .fltSld-connect {
    height: 4px;
  }

  & .fltSld-connect-0 {
    background: #2276e3;
  }

  & .fltSld-connect-1 {
    background: none;
  }

  & .fltSld-handle {
    background: #2276e3;
    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);
    border-radius: 4px;

    padding: 6px 2px;
    font-size: 12px;
    top: -37px;
    font-weight: 700;
    width: 50px;
    text-align: center;
    margin: 0 0 0 23px;
    border: none;
    &:before {
      content: '';
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #2276e3;
      position: absolute;
      bottom: -7px;
      left: 17px;
    }
  }
`;
